const BASE = '/api';

async function req(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Något gick fel.');
  return data;
}

export const api = {
  getPackages:      ()  => req('/courses/packages'),
  getTheoryPackages:()  => req('/courses/theory'),
  getRiskCourses:   ()  => req('/courses/risk'),
  getRiskCourse:    (id)=> req(`/courses/risk/${id}`),
  getInstructors:   ()  => req('/courses/instructors'),
  getPosts:         (p) => req(`/blog${p ? '?'+new URLSearchParams(p) : ''}`),
  getPost:          (s) => req(`/blog/${s}`),
  createBooking:    (d) => req('/bookings',        { method:'POST', body:JSON.stringify(d) }),
  createRiskBooking:(d) => req('/bookings/risk',   { method:'POST', body:JSON.stringify(d) }),
  createTheoryBooking:(d)=>req('/bookings/theory', { method:'POST', body:JSON.stringify(d) }),
  sendContact:      (d) => req('/contact',         { method:'POST', body:JSON.stringify(d) }),
  subscribe:        (e) => req('/newsletter/subscribe', { method:'POST', body:JSON.stringify({ email:e }) }),
};
